import type { AjaxResponse } from 'rxjs';
import { Observable } from 'rxjs';
import { post } from '@helpcenter/ajax';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { contextPath } from '@atlassian/help-center-common-util/history';

export const invitedSignUp = (params: {
    portalId: number;
    email: string;
    fullName: string;
    password: string;
    token: string;
    username: string;
    context?: string;
    setPasswordJwt: string | undefined;
}) => {
    const { portalId, email, fullName, password, token, username, setPasswordJwt, context = contextPath } = params;
    const isConvertInviteTokenToJwtEnabled = FeatureGates.checkGate('convert_invite_token_to_jwt');
    const uri =
        isConvertInviteTokenToJwtEnabled && setPasswordJwt
            ? `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword?jwt=${setPasswordJwt}`
            : `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword`;
    const body = {
        fullName,
        password,
        username,
        email,
        // eslint-disable-next-line no-nested-ternary
        ...(isConvertInviteTokenToJwtEnabled ? (token ? { token } : {}) : { token }),
    };

    const headers = {
        'Content-Type': 'application/json',
    };

    return (
        post(uri, body, headers)
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .map(({ response }: AjaxResponse) => response)
            .catch((e) => {
                return Observable.throw(e);
            })
    );
};
